import React from 'react';
import PropTypes from 'prop-types';
import { Pagination as BootstrapPagination } from 'react-bootstrap';
import styles from './styles.module.styl';

const Pagination = ({ activePage, pageCount, handleSelect }, context) => {

  return (
    <div className={styles.paginationContainer}>
      <BootstrapPagination
        prev={activePage > 1 && '‹ Previous'}
        next={activePage < pageCount && 'Next ›'}
        first={activePage > 1 && '« First'}
        last={activePage < pageCount && 'Last »'}
        items={pageCount}
        maxButtons={10}
        ellipsis={false}
        activePage={+activePage}
        onSelect={handleSelect}
      />
      <div>
        Didn&apos;t find what you are looking for?&nbsp;&nbsp;
        <a
          href="https://community.auth0.com/"
          onClick={() => context.trackEvent('click:view-community')}
          target="_blank"
          rel="noreferrer noopener"
        >Ask the Auth0 Community</a>
      </div>
    </div>
  );
};

Pagination.propTypes = {
  activePage: PropTypes.string.isRequired,
  pageCount: PropTypes.number.isRequired,
  handleSelect: PropTypes.func.isRequired
};

Pagination.contextTypes = {
  trackEvent: PropTypes.func.isRequired
};

export default Pagination;
